import { Injectable } from '@angular/core';
import { LocalstorageService } from './localstorage.service';
import { CartObserverService } from './cart-observer.service';


export type TProductType = 'granel' | 'pza' | 'pza-grammage' | 'grammage';

@Injectable({
  providedIn: 'root'
})
export class ProductsValidationsService {

  constructor(
    private localStorageService: LocalstorageService,
    private cartObserver: CartObserverService,

  ) { }

  public productCartTypeValidation(unit: string, weight: string | null): TProductType {
    switch (unit) {
      case 'granel':
        return 'granel';
      case 'pza':
        return !weight ? 'pza' : 'pza-grammage';
      case 'grammage':
        return !weight ? 'grammage' : 'pza-grammage';
      default:
        return 'pza';
    }
  }

  public editProductInLocalStorage(productToEdit: any): void {
    let items = this.localStorageService.getProperty('cartItems');
    items = items.map((item: any) => {
      if (item.item_id === productToEdit.itemId) {
        item.pendingToAdd = productToEdit;
      }
      return { ...item };
    });
    this.localStorageService.setProperty('cartItems', items);

    const counter = this.setCartCounter(items);

    this.cartObserver.setdatauser(counter);
  }

  public setCartCounter(items: any): number {
    let counter = 0;
    for (const c of items) {
      const pendingToAdd = c.pendingToAdd || {};
      const productType = this.productCartTypeValidation(pendingToAdd.unit?.toLowerCase() || c.unit.toLowerCase(), c.weight);
      let quantityToAdd = pendingToAdd.quantity || c.quantity;
      if (productType === 'pza-grammage' || productType === 'grammage') {
        quantityToAdd /= Number.parseFloat(c.weight);
        quantityToAdd = Number.parseInt(quantityToAdd.toFixed(2));
      } else if (productType === 'granel') {
        quantityToAdd = pendingToAdd.quantity || c.quantity;
        quantityToAdd = 1;
        quantityToAdd = Number.parseInt(quantityToAdd.toFixed(2));
      } else if (productType === 'pza') {
        quantityToAdd = pendingToAdd.quantity || c.quantity;
      }

      counter += quantityToAdd;
    }

    if (this.getFloatDecimalPortion(counter) !== 0) {
      counter = Math.round(counter) + 1;
    }

    return counter;
  }

  private getFloatDecimalPortion(x: any): number {
    x = Math.abs(parseFloat(x));
    const n = parseInt(x);
    return Number((x - n).toFixed(Math.abs(('' + x).length - ('' + n).length - 1)));
  }

}
